import { render, staticRenderFns } from "./Jiangpingliebiao.vue?vue&type=template&id=f99a8780&scoped=true&"
import script from "./Jiangpingliebiao.vue?vue&type=script&lang=js&"
export * from "./Jiangpingliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Jiangpingliebiao.vue?vue&type=style&index=0&id=f99a8780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a8780",
  null
  
)

export default component.exports